'use client';

import { useRouter } from '@bprogress/next/app';

import { UiArticleSectionFaq } from '@/fo/ui/article/section/faq';
import { UiArticleSectionSupport } from '@/fo/ui/article/section/support';
import { utilEventAuthModal } from '@/fo/util/event-auth-modal';

import { BenefitsSection } from '../components/BenefitsSection/BenefitsSection';
import { BrandsSection } from '../components/BrandsSection/BrandsSection';
import { DiscountBanner } from '../components/DiscountBanner/DiscountBanner';
import { HeroBanner } from '../components/HeroBanner/HeroBanner';
import { JoinSection } from '../components/JoinSection/JoinSection';
import { LevelsSection } from '../components/LevelsSection/LevelsSection';
import { PointsSection } from '../components/PointsSection/PointsSection';

import { styles } from './UiArticlePageLoyalty.styles';

interface UiArticlePageLoyaltyProps {
  isAuth: boolean;
}

const accountRoutes = {
  loyalty: '/account/loyalty/',
  private: '/account/loyalty/#loyalty-referral',
  loyaltyProducts: '/account/loyalty/#loyalty-products',
  typeSkin: '/account/#type_skin'
};

export function UiArticlePageLoyalty({ isAuth }: UiArticlePageLoyaltyProps) {
  const router = useRouter();

  const slots = styles();

  const openAccountRoute = (path: string) => () => {
    if (!isAuth) {
      utilEventAuthModal.open('loyalty');
      return;
    }

    router.push(path);
  };

  const handleClickLoyalty = openAccountRoute(accountRoutes.loyalty);
  const handleClickPrivate = openAccountRoute(accountRoutes.private);
  const handleClickTypeSkin = openAccountRoute(accountRoutes.typeSkin);
  const handleClickLoyaltyProducts = openAccountRoute(
    accountRoutes.loyaltyProducts
  );

  return (
    <div className={slots.base()}>
      <HeroBanner onClick={handleClickLoyalty} />
      <BrandsSection />
      <BenefitsSection />
      <DiscountBanner onClick={handleClickLoyalty} />
      <LevelsSection
        onClick={handleClickLoyalty}
        onTypeSkinClick={handleClickTypeSkin}
      />
      <PointsSection
        onClickPrivate={handleClickPrivate}
        onClickLoyalty={handleClickLoyalty}
        onClickLoyaltyProducts={handleClickLoyaltyProducts}
      />

      <div className={slots.faq()}>
        <UiArticleSectionFaq onClickTypeSkin={handleClickTypeSkin} />
      </div>

      <div className={slots.support()}>
        <UiArticleSectionSupport />
      </div>

      <JoinSection onClickLoyalty={handleClickLoyalty} />
    </div>
  );
}
